import Loadable from '@react-loadable/revised';

const LoadableVideoPlayer = Loadable({
    loader: () => import('./VideoPlayer'),
    loading: () => null
});

export default LoadableVideoPlayer;
